export default __webpack_public_path__ + "media/titles/title_3_locale_fr-c57b75db.png";